import React, { useEffect, useState } from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import { Box, Button, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert, Chip, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import axiosInstance from '../utils/axios';
import { startOfDay, endOfDay, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, subYears, addYears } from 'date-fns';

import { getStats } from '../services/statsService';
export default function Withdrawals() {
  const theme = useTheme();
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [signingId, setSigningId] = useState(null); // id выплаты, которую подписываем
  const [showModal, setShowModal] = useState(false); // показывать ли модалку
  const [paymentPassword, setPaymentPassword] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalBaseAmount, setTotalBaseAmount] = useState(0);
  const [copyAlert, setCopyAlert] = useState(false);

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const fetchWithdrawals = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/withdrawals');
      setWithdrawals(res.data.data);
      let ammo = 0;
      res.data.data.forEach((w) => {
        ammo += w.amountRUB;
        console.log('ammo', ammo)
      });
      const startDate = startOfDay(new Date('2024-01-01'));
      const endDate = endOfDay(new Date('2060-01-01'));
      const stats = await getStats(startDate, endDate);
      setTotalBaseAmount(stats.totalBaseSum);
      setTotalAmount(ammo);
      console.log('totalAmount', totalAmount)
      console.log('totalBaseAmount', totalBaseAmount)
      
    } catch (err) {
      console.log(err)
      setError('Ошибка загрузки выплат');
    }
    setLoading(false);
  };

  const handleSign = (id) => {
    setSigningId(id);
    setPaymentPassword('');
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSigningId(null);
    setPaymentPassword('');
    setError('');
  };

  const [modalError, setModalError] = useState('');

  const handleModalConfirm = async () => {
    if (!paymentPassword) {
      setModalError('Введите пароль');
      return;
    }
    try {
      setLoading(true);
      setModalError('');
      setError('');
      await axiosInstance.post(`/${signingId}/sign`, { secret: paymentPassword });
      setSuccess('Выплата подписана!');
      setShowModal(false);
      setSigningId(null);
      setPaymentPassword('');
      // обновить список выплат
      await fetchWithdrawals();
    } catch (e) {
      setShowModal(false);
      setSigningId(null);
      setPaymentPassword('');
      setError(e.response?.data?.error || 'Ошибка при подписании');
    } finally {
      setLoading(false);
    }
  };

  const handleAlertClose = () => setError('');

  const handleCopyTx = async (tx) => {
    try {
      await navigator.clipboard.writeText(tx);
      setCopyAlert(true);
      setTimeout(() => setCopyAlert(false), 1500);
    } catch {
      // ignore
    }
  }
  const debt = totalBaseAmount - totalAmount;

  return (
    <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
      <Typography variant="h4" component="h1" sx={{ mb: 1 }}>Выплаты</Typography>
      <Typography color="text.secondary" variant="body2">Баланс, история переводов и подписание выплат</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 2, my: 3 }}>
        {[
          { label: 'Заработано', value: totalBaseAmount, color: theme.palette.primary.main },
          { label: 'Выплачено', value: totalAmount, color: theme.palette.secondary.main },
          { label: 'Долг', value: debt, color: debt > 0 ? theme.palette.error.main : theme.palette.success.main },
        ].map(item => (
          <Paper key={item.label} elevation={0} sx={{ p: 2.5, border: 1, borderColor: 'divider', borderTopColor: alpha(item.color, 0.5), minWidth: 0 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{item.label}</Typography>
            <Typography variant="h5" sx={{ color: item.color, fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere' }}>{item.value.toLocaleString('ru-RU', {maximumFractionDigits: 2})} ₽</Typography>
          </Paper>
        ))}
      </Box>
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 4 }}><CircularProgress size={22} /><Typography color="text.secondary">Загрузка...</Typography></Box>
      ) : (
        <TableContainer component={Paper} elevation={0} sx={{ border: 1, borderColor: 'divider' }}>
          <Table sx={{ minWidth: 960 }}>
            <TableHead>
              <TableRow>
                {['ID', 'Сумма (₽)', 'Курс BTC', 'Курс USDT', 'Tx Hash', 'Период', 'Создано', 'Статус / Действие'].map(label => <TableCell key={label}>{label}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {withdrawals.map(w => (
                <TableRow key={w._id} hover>
                  <TableCell sx={{ fontSize: 12, color: 'text.secondary', fontFamily: 'monospace' }}>{w._id}</TableCell>
                  <TableCell sx={{ fontWeight: 650 }}>{w.amountRUB}</TableCell>
                  <TableCell>{w.rateBTC}</TableCell>
                  <TableCell>{w.rateUSDT}</TableCell>
                  <TableCell sx={{ maxWidth: 180, wordBreak: 'break-all', fontFamily: 'monospace', fontSize: 13 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span title={w.btcTxId}>{w.btcTxId?.length > 15 ? w.btcTxId.slice(0, 8) + '...' + w.btcTxId.slice(-5) : w.btcTxId}</span>
                      {w.btcTxId && <IconButton size="small" color="primary" aria-label="Скопировать Tx Hash" onClick={() => handleCopyTx(w.btcTxId)}><ContentCopyIcon sx={{ fontSize: 16 }} /></IconButton>}
                    </Box>
                  </TableCell>
                  <TableCell>{w.period}</TableCell>
                  <TableCell>{w.createdAt ? new Date(w.createdAt).toLocaleString() : ''}</TableCell>
                  <TableCell>{w.signed ? <Chip label="Подписано" size="small" variant="outlined" color="success" /> : <Button size="small" variant="outlined" onClick={() => handleSign(w._id)}>Подписать</Button>}</TableCell>
                </TableRow>
              ))}
              {withdrawals.length === 0 && <TableRow><TableCell colSpan={8} align="center" sx={{ py: 5, color: 'text.secondary' }}>Выплат пока нет</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {error && <Alert severity="error" onClose={handleAlertClose} sx={{ mt: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
      {copyAlert && <Alert severity="info" sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1500, bgcolor: 'background.paper' }}>Tx Hash скопирован!</Alert>}
      {/* Модальное окно для ввода пароля */}
      <Dialog open={showModal} maxWidth="xs" fullWidth aria-labelledby="sign-withdrawal-title">
        <DialogTitle id="sign-withdrawal-title">Подписать выплату</DialogTitle>
        <DialogContent>
          <TextField fullWidth type="password" label="Платежный пароль" value={paymentPassword} onChange={e => setPaymentPassword(e.target.value)} autoFocus />
          {modalError && <Alert severity="error" sx={{ mt: 2 }}>{modalError}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="inherit">Отмена</Button>
          <Button onClick={handleModalConfirm} variant="contained">Подписать</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}



